import type { AxiosResponse } from 'axios';
import { adminAxios } from 'utils/adminAxios';
import { organizationsApi } from './api';

export const getOrganizationsSearch = async (): Promise<AxiosResponse> => {
  return await adminAxios.get(organizationsApi.path);
};
